import { default as _91_46_46_46cms_93mlQQM113u0Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93bjjQKAyMDEMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/3d-projects/[...slug].vue?macro=true";
import { default as index39k6TQ6J76Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93Ze7IDOwW36Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/akcii/[...slug].vue?macro=true";
import { default as indexqos7YK5rRkMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93FDeTDHLkXKMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/articles/[...slug].vue?macro=true";
import { default as indexjiJtUiuUmvMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/articles/index.vue?macro=true";
import { default as index8vjZdCdmFWMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/authorization/index.vue?macro=true";
import { default as indexceHb71kl24Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93iSmwDFF8X9Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93MuhqggozB1Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/catalog/[...slug].vue?macro=true";
import { default as indexKK1Pk2bYSbMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93cuRoxNKloaMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultEt2TsEPHOAMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/catalogsearch/result.vue?macro=true";
import { default as indexkErpoo9DwRMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93HBKEezd4mHMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93yhSOKNrBeFMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/fabriki/[...slug].vue?macro=true";
import { default as indexlHXqB2Ls67Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93J4Akd7ltRIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93slSmJX1hL5Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/product/[...slug].vue?macro=true";
import { default as indexM08JHOmtgMMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/profile/index.vue?macro=true";
import { default as indexG678KyOhfxMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/profile/orders/index.vue?macro=true";
import { default as indexNxRBXy0uv1Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93kANTPekwhxMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/sets/[...slug].vue?macro=true";
import { default as indexW2krdGIZ5CMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93mlQQM113u0Meta?.name ?? "cms",
    path: _91_46_46_46cms_93mlQQM113u0Meta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93mlQQM113u0Meta || {},
    alias: _91_46_46_46cms_93mlQQM113u0Meta?.alias || [],
    redirect: _91_46_46_46cms_93mlQQM113u0Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93bjjQKAyMDEMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93bjjQKAyMDEMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93bjjQKAyMDEMeta || {},
    alias: _91_46_46_46slug_93bjjQKAyMDEMeta?.alias || [],
    redirect: _91_46_46_46slug_93bjjQKAyMDEMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index39k6TQ6J76Meta?.name ?? "3d-projects",
    path: index39k6TQ6J76Meta?.path ?? "/3d-projects",
    meta: index39k6TQ6J76Meta || {},
    alias: index39k6TQ6J76Meta?.alias || [],
    redirect: index39k6TQ6J76Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Ze7IDOwW36Meta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93Ze7IDOwW36Meta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93Ze7IDOwW36Meta || {},
    alias: _91_46_46_46slug_93Ze7IDOwW36Meta?.alias || [],
    redirect: _91_46_46_46slug_93Ze7IDOwW36Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexqos7YK5rRkMeta?.name ?? "akcii",
    path: indexqos7YK5rRkMeta?.path ?? "/akcii",
    meta: indexqos7YK5rRkMeta || {},
    alias: indexqos7YK5rRkMeta?.alias || [],
    redirect: indexqos7YK5rRkMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93FDeTDHLkXKMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93FDeTDHLkXKMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93FDeTDHLkXKMeta || {},
    alias: _91_46_46_46slug_93FDeTDHLkXKMeta?.alias || [],
    redirect: _91_46_46_46slug_93FDeTDHLkXKMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexjiJtUiuUmvMeta?.name ?? "articles",
    path: indexjiJtUiuUmvMeta?.path ?? "/articles",
    meta: indexjiJtUiuUmvMeta || {},
    alias: indexjiJtUiuUmvMeta?.alias || [],
    redirect: indexjiJtUiuUmvMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: index8vjZdCdmFWMeta?.name ?? "authorization",
    path: index8vjZdCdmFWMeta?.path ?? "/authorization",
    meta: index8vjZdCdmFWMeta || {},
    alias: index8vjZdCdmFWMeta?.alias || [],
    redirect: index8vjZdCdmFWMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexceHb71kl24Meta?.name ?? "cart",
    path: indexceHb71kl24Meta?.path ?? "/cart",
    meta: indexceHb71kl24Meta || {},
    alias: indexceHb71kl24Meta?.alias || [],
    redirect: indexceHb71kl24Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93iSmwDFF8X9Meta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93iSmwDFF8X9Meta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93iSmwDFF8X9Meta || {},
    alias: _91_46_46_46id_93iSmwDFF8X9Meta?.alias || [],
    redirect: _91_46_46_46id_93iSmwDFF8X9Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93MuhqggozB1Meta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93MuhqggozB1Meta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93MuhqggozB1Meta || {},
    alias: _91_46_46_46slug_93MuhqggozB1Meta?.alias || [],
    redirect: _91_46_46_46slug_93MuhqggozB1Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexKK1Pk2bYSbMeta?.name ?? "catalog",
    path: indexKK1Pk2bYSbMeta?.path ?? "/catalog",
    meta: indexKK1Pk2bYSbMeta || {},
    alias: indexKK1Pk2bYSbMeta?.alias || [],
    redirect: indexKK1Pk2bYSbMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93cuRoxNKloaMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93cuRoxNKloaMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93cuRoxNKloaMeta || {},
    alias: _91_46_46_46slug_93cuRoxNKloaMeta?.alias || [],
    redirect: _91_46_46_46slug_93cuRoxNKloaMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultEt2TsEPHOAMeta?.name ?? "catalogsearch-result",
    path: resultEt2TsEPHOAMeta?.path ?? "/catalogsearch/result",
    meta: resultEt2TsEPHOAMeta || {},
    alias: resultEt2TsEPHOAMeta?.alias || [],
    redirect: resultEt2TsEPHOAMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexkErpoo9DwRMeta?.name ?? "clear-page-slider",
    path: indexkErpoo9DwRMeta?.path ?? "/clear-page-slider",
    meta: indexkErpoo9DwRMeta || {},
    alias: indexkErpoo9DwRMeta?.alias || [],
    redirect: indexkErpoo9DwRMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93HBKEezd4mHMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93HBKEezd4mHMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93HBKEezd4mHMeta || {},
    alias: _91_46_46_46slug_93HBKEezd4mHMeta?.alias || [],
    redirect: _91_46_46_46slug_93HBKEezd4mHMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93yhSOKNrBeFMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93yhSOKNrBeFMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93yhSOKNrBeFMeta || {},
    alias: _91_46_46_46slug_93yhSOKNrBeFMeta?.alias || [],
    redirect: _91_46_46_46slug_93yhSOKNrBeFMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexlHXqB2Ls67Meta?.name ?? "fabriki",
    path: indexlHXqB2Ls67Meta?.path ?? "/fabriki",
    meta: indexlHXqB2Ls67Meta || {},
    alias: indexlHXqB2Ls67Meta?.alias || [],
    redirect: indexlHXqB2Ls67Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93J4Akd7ltRIMeta?.name ?? "order-status-hash",
    path: _91hash_93J4Akd7ltRIMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93J4Akd7ltRIMeta || {},
    alias: _91hash_93J4Akd7ltRIMeta?.alias || [],
    redirect: _91hash_93J4Akd7ltRIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93slSmJX1hL5Meta?.name ?? "product-slug",
    path: _91_46_46_46slug_93slSmJX1hL5Meta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93slSmJX1hL5Meta || {},
    alias: _91_46_46_46slug_93slSmJX1hL5Meta?.alias || [],
    redirect: _91_46_46_46slug_93slSmJX1hL5Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexM08JHOmtgMMeta?.name ?? "profile",
    path: indexM08JHOmtgMMeta?.path ?? "/profile",
    meta: indexM08JHOmtgMMeta || {},
    alias: indexM08JHOmtgMMeta?.alias || [],
    redirect: indexM08JHOmtgMMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexG678KyOhfxMeta?.name ?? "profile-orders",
    path: indexG678KyOhfxMeta?.path ?? "/profile/orders",
    meta: indexG678KyOhfxMeta || {},
    alias: indexG678KyOhfxMeta?.alias || [],
    redirect: indexG678KyOhfxMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexNxRBXy0uv1Meta?.name ?? "recently",
    path: indexNxRBXy0uv1Meta?.path ?? "/recently",
    meta: indexNxRBXy0uv1Meta || {},
    alias: indexNxRBXy0uv1Meta?.alias || [],
    redirect: indexNxRBXy0uv1Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93kANTPekwhxMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93kANTPekwhxMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93kANTPekwhxMeta || {},
    alias: _91_46_46_46slug_93kANTPekwhxMeta?.alias || [],
    redirect: _91_46_46_46slug_93kANTPekwhxMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexW2krdGIZ5CMeta?.name ?? "wishlist",
    path: indexW2krdGIZ5CMeta?.path ?? "/wishlist",
    meta: indexW2krdGIZ5CMeta || {},
    alias: indexW2krdGIZ5CMeta?.alias || [],
    redirect: indexW2krdGIZ5CMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260925080922/pages/wishlist/index.vue").then(m => m.default || m)
  }
]